import { BlockConfig, OperationTypes, ContentTypes } from "../block-base";
import { BlockTypes } from "../block-types";

export const dbReadReplicaConfig: BlockConfig = {
  displayName: "DB Read Replica",
  imagePath: "",
  isInitiator: true,
  isTerminator: false,
  isInterceptor: false,
  allowedInputTypes: new Set([
    BlockTypes.APP_SERVER,
    BlockTypes.AUTO_SCALING_GROUP,
    BlockTypes.CACHE,
    BlockTypes.LAMBDA,
    BlockTypes.NETWORK_LOAD_BALANCER,
    BlockTypes.PASSTHROUGH,
  ]),
  allowedOutputTypes: new Set(),
  inputCapacity: {
    total: 15000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 15000,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 2000,
          [`${ContentTypes.STATIC}`]: 8000,
          [`${ContentTypes.STATIC_MEDIA}`]: 5000,
        },
      },
    },
  },
  processingCapacity: {
    total: 15000,
    byOperationType: {
      [`${OperationTypes.READ}`]: {
        total: 15000,
        byContentType: {
          [`${ContentTypes.DYNAMIC}`]: 2000,
          [`${ContentTypes.STATIC}`]: 8000,
          [`${ContentTypes.STATIC_MEDIA}`]: 5000,
        },
      },
    },
  },
  purchasePrice: 100,
  sellPrice: 50,
  costPerCycle: 0.8,
  outputConnectorLimits: {},
};
